/**
 * Created by mh on 2018/9/29.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer, inject } from 'mobx-react';
import { observable, computed } from 'mobx';

import { Switch, Redirect, Link } from 'react-router-dom';
import PrivateRoute from '../PrivateRoute.jsx';

import Spinner from '../Spinner';
import ArtworkReplacementTile from './ArtworkReplacementTile';

const availableReplacementServices = [
    {
        name: 'IFPI SoundExchange',
        type: 'soundexchange',
    },
];

const MsToTime = (duration) => {
    const milliseconds = parseInt((duration % 1000) / 100, 10);
    let seconds = parseInt((duration / 1000) % 60, 10);
    let minutes = parseInt((duration / (1000 * 60)) % 60, 10);
    let hours = parseInt((duration / (1000 * 60 * 60)) % 24, 10);

    hours = (hours < 10) ? `0${hours}` : hours;
    minutes = (minutes < 10) ? `0${minutes}` : minutes;
    seconds = (seconds < 10) ? `0${seconds}` : seconds;

    return `${hours}:${minutes}:${seconds}.${milliseconds}`;
};

const CountOccurences = (array) => {
    const counters = array.reduce((acc, curr) => {
        if (typeof acc[curr] === 'undefined') {
            acc[curr] = 1;
        } else {
            acc[curr] += 1;
        }
        return acc;
    }, {});

    const result =  Object.keys(counters).map(k => ({ isrc: k, count: counters[k] }));
    return result.sort((a, b) => (a.count >= b.count ? -1 : 1)).slice(0, Math.min(8, result.length));
};

const MetadataReplacementList = observer(({ service, replacements, replaceAction }) => {
    const mostISRC = CountOccurences(replacements.map(repl => repl.metadata.isrc));
    return (
        <div>
            <div className="row">
                <div className="col">
                    Retrieved {replacements.length} metadata elements from {service.name}
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col">
                    Most common ISRCs
                </div>
            </div>
            <div className="row">
                {mostISRC.map((isrc, index) => (
                    <div className="col-lg-3 col-sm-3 col-6 mt-1">
                        <button type="button" className="btn btn-primary btn-block" onClick={() => replaceAction("ISRC", isrc.isrc)} >
                            {isrc.isrc} ({isrc.count})
                        </button>
                    </div>
                ))}
            </div>
            <hr />
            <div className="row">
                {replacements.map((repl, index) => (
                    <div key={`meta_replace_${index}`} className="col-lg-3 col-sm-3 col-6 mt-1">
                        <div className="card">
                            <div className="card-body">
                                <h6 className="card-title">
                                    {repl.metadata.title}
                                </h6>
                                <p className="card-text">
                                    <small>{repl.metadata.artist}</small>
                                </p>
                                <p className="card-text">
                                    <small>{repl.metadata.album}</small>
                                </p>
                                <p className="card-text">
                                    <small>{repl.metadata.isrc}</small>
                                </p>
                                <p className="card-text">
                                    <small>{repl.metadata.label}</small>
                                </p>
                                <p className="card-text">
                                    <small>{repl.metadata.recording_version}</small>
                                </p>
                                <p className="card-text">
                                    <small>{repl.metadata.recording_year}</small>
                                </p>
                                <p className="card-text">
                                    <small>{repl.metadata.release_version}</small>
                                </p>
                                <p className="card-text">
                                    <small>{repl.metadata.release_date}</small>
                                </p>
                                <p className="card-text">
                                    <small>{MsToTime(repl.metadata.duration_ms)}</small>
                                </p>
                            </div>
                            <div className="card-footer">
                                <button type="button" className="btn btn-primary btn-block" onClick={replaceAction} disabled={!false ? 'disabled' : false} >
                                    <FormattedMessage
                                        id="Assets.ReplaceArtwork.ReplaceArtwork"
                                        defaultMessage="Replace"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
});

@inject('assets')
@observer
class SearchMetadata extends Component {
    componentDidMount = () => {
    };

    componentWillReceiveProps = (nextProps) => {
        const { match } = this.props;
        if (nextProps.match.params.id !== match.params.id) {
            // Id changes
            // this.fetchData(nextProps.match.params.id);
            this.replacementOptions = [];
            this.replacingMetadata = false;
            this.replacedMetadata = false;
            this.replacementData = [];
        }
    };

    @observable
    replacementOptions = [];

    @observable
    replacingMetadata = false;

    @observable
    replacedMetadata = false;

    @observable
    replacementData = [];

    @observable
    replacementService = null;


    @computed
    get hasReplacements() {
        return this.replacementOptions && this.replacementOptions.length > 0;
    }

    fetchData = (service) => {
        // Set local service and fetch data
        this.replacementService = service;
        const { assets, match: { params: { id } } } = this.props;
        assets.fetchMetadataReplacements(id, this.replacementService.type);
    };

    replaceMetadata = async (fieldKey, value) => {
        const { match } = this.props;
        console.log(`Replacing asset metadata of ${match.params.id} with`, `${fieldKey}`, value);
        this.replacingMetadata = true;
        
        const assetId = match.params.id;

        // Step 1 - update the metadata field by key and value
        const { assets } = this.props;

        try {
            const { metadata } = assets.asset;
            metadata[fieldKey] = value;

            const updatedAsset = await assets.updateAssetMetadata(assetId, metadata);
            // TODO callback is bad
            console.log('Updated Artwork Asset', updatedAsset);
        } catch (err) {
            // TODO Handle
            console.log(err);
            // Redirect to the new asset
            this.replaceMetadata = false;
            this.replacedMetadata = true;
            return;
        }

        // RELOAD Asset
        // TODO provide other way of reloading the asset using dirty method or dirty flag
        // assets.fetchAsset(assetId);
        // assets.fetchRelated(audioId);

        // Redirect to the new asset
        this.replaceMetadata = false;
        this.replacedMetadata = true;
    };

    render() {
        const {
            assets: {
                fetchingMetadata,
                fetchedMetadata,
                assetMetadataReplacements,
            },
            match,
        } = this.props;
        return this.replacedMetadata ? <Redirect to={match.url.replace('/replacemetadata', '/details')} /> : (
            <div className="mt-3">
                <h3>
                    <FormattedMessage
                        id="Assets.ReplaceMetadata.Search"
                        defaultMessage="Search metadata"
                    />
                </h3>
                <Switch>
                    <PrivateRoute
                        exact
                        path={`${match.path}/`}
                        component={() => {
                            console.log(availableReplacementServices);

                            if (availableReplacementServices.length === 1) {
                                this.fetchData(availableReplacementServices[0]);
                                return <Redirect to={`${match.url}${match.url.endsWith('/') ? '' : '/'}${availableReplacementServices[0].type}/`} />;
                            }

                            return availableReplacementServices.map(service => (
                                <Link key={service.type} onClick={() => this.fetchData(service)} className="btn btn-primary mr-2" to={`${match.url}${match.url.endsWith('/') ? '' : '/'}${service.type}`}>
                                    <FormattedMessage
                                        id={`Assets.ReplaceMetadata.SearchOn_${service.type}`}
                                        defaultMessage={`Search on ${service.name}`}
                                    />
                                </Link>
                            ));
                        }
                        }
                    />
                    <PrivateRoute
                        exact
                        path={`${match.path}soundexchange`}
                        component={observer(() => {
                            if (this.replacingMetadata) {
                                return <Spinner />;
                            }
                            if (fetchingMetadata || !fetchedMetadata) {
                                return <Spinner />;
                            }
                            return <MetadataReplacementList service={this.replacementService} replacements={assetMetadataReplacements} replaceAction={this.replaceMetadata} />;
                        })
                        } />

                </Switch>
            </div>
        );
    }
}

SearchMetadata.wrappedComponent.propTypes = {
    // auth: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    assets: PropTypes.object,
};

export default injectIntl(SearchMetadata);
